<script setup>
import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/vue";
import { ChevronDownIcon } from "@heroicons/vue/24/solid";
import { onMounted, ref } from "vue";

const props = defineProps({
  title: {
    type: String,
    required: true
  },
  icon: {
    type: [Object, Function],
    required: false,
    default: null
  },
  active: {
    type: Boolean,
    required: false,
    default: false
  },
  defaultOpen: {
    type: Boolean,
    required: false,
    default: false
  },
  level: {
    type: Number,
    required: false,
    default: 0
  },
  setCurrentDisclosure: {
    type: Function,
    required: false
  },
  alwaysOpen: {
    type: Boolean,
    required: false,
    default: false
  }
});

const disclosure = ref(null);

function toggleButton() {
  if (props.setCurrentDisclosure) {
    props.setCurrentDisclosure(disclosure.value);
  }
}

onMounted(() => {
  if (props.active && props.setCurrentDisclosure) {
    props.setCurrentDisclosure(disclosure.value);
  }
});
</script>

<template>
  <Disclosure
    ref="disclosure"
    v-slot="{ open }"
    :default-open="props.active || props.defaultOpen || props.alwaysOpen"
    as="div"
    class="flex flex-col"
    :class="{
      'always-open': props.alwaysOpen,
    }"
  >
    <DisclosureButton
      class="menu-disclosure-button group flex w-full items-center gap-2 truncate rounded-lg p-2 duration-150 hover:bg-indigo-600 hover:text-white"
      :class="{
        'bg-gray-200 text-slate-600':
          open || props.active,
      }"
      :title="props.title"
      @click="toggleButton"
    >
      <component
        v-if="props.icon && props.level === 0"
        :is="props.icon"
        class="size-5 flex-shrink-0 flex-grow-0 text-gray-400 group-hover:text-white"
      />

      <div :class="{ 'truncate text-left': level === 0, 'pl-7': level === 1 }">
        {{ props.title }}
      </div>

      <ChevronDownIcon
        class="ml-auto size-4 flex-shrink-0 flex-grow-0 text-gray-400 duration-150 group-hover:text-white"
        :class="{ 'rotate-180 transform': open }"
      />
    </DisclosureButton>

    <DisclosurePanel class="mt-2">
      <div class="flex flex-col gap-2">
        <slot :disclosure="disclosure" />
      </div>
    </DisclosurePanel>
  </Disclosure>
</template>
